import { useEffect, useRef, useState } from "react";
import { Input } from "reactstrap";

const PositionItemRow = ({ keyId, item, onRowSelectionChange, initialQuantity = 1 }) => {
    const [quantity, setQuantity] = useState(initialQuantity);
    const isMounted = useRef(false);
    
    const handleQuantityChange = (target, newValue) => {
        const value = newValue === "" ? "" : parseInt(newValue, 10);

        if (newValue === "") {
            setQuantity("");
            target.setCustomValidity(""); // limpiar error
            return;
        }

        if (isNaN(value) || value === 0) {
            setQuantity("");
            target.setCustomValidity("El valor debe ser un número mayor que 0");
            target.reportValidity();
            return;
        }

        // si pasa todas las validaciones
        setQuantity(value);
        target.setCustomValidity(""); // limpiar error
    };

    useEffect(() => {
        // No emitir en el primer render, solo en cambios posteriores
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }
        onRowSelectionChange(item.value, quantity);
    }, [quantity]);

    return (
        <tr key={keyId}>

            <td className="text-center align-middle">
                <Input
                    type="text"
                    min="1"
                    max={"200"}
                    value={quantity}
                    onChange={
                        (e) => 
                            handleQuantityChange(
                                e.target,
                                e.target.value
                            )
                    }
                />
            </td>
            <td className="text-center align-middle">{item.name.toUpperCase()}</td>
        </tr>
    );
}

export default PositionItemRow;